/** API_SPEC.md §3 — me / account. */
import { api } from './client';
import type { LegalAcceptanceRequest, MePatch, MeResponse } from './types';

export const meApi = {
  get: () => api<MeResponse>('/v1/me'),
  patch: (body: MePatch) => api<MeResponse>('/v1/me', { method: 'PATCH', body }),
  requestEmailChange: (email: string) => api<MeResponse>('/v1/me/email-change', { method: 'POST', body: { email } }),
  cancelEmailChange: () => api<MeResponse>('/v1/me/email-change', { method: 'DELETE' }),
  deleteAccount: () => api<void>('/v1/me', { method: 'DELETE' }),
  /**
   * Records that the account agreed to a version of a legal document from
   * inside the app (legal-pages ticket 02). 200 with the `me` shape whether or
   * not it wrote a row; its `legal.termsVersions` then holds the version posted
   * (`legal.termsVersion` is the latest by time, which can be another). Limited to 10 an hour per account,
   * and a call that writes nothing still spends one: call it on the user's
   * click, never on load and never in a retry loop.
   */
  acceptLegal: (body: LegalAcceptanceRequest) => api<MeResponse>('/v1/me/legal-acceptances', { method: 'POST', body }),
};
